export const seller = {
	sellerId: '1',
	sellerName: 'Maeztra Store Theme',
	addToCartLink:
		'https://maeztraio.vtexcommercestable.com.br/checkout/cart/add?sku=16&qty=1&seller=1&sc=1&price=79900&cv=EAAEBCAC1E264AA392D6D5FD37BEC108_&sc=1',
	sellerDefault: true,
	commertialOffer: {
		DeliverySlaSamplesPerRegion: {
			0: {
				DeliverySlaPerTypes: [],
				Region: null,
			},
		},
		Installments: [
			{
				Value: 799,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 399.5,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 2,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 266.33,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 3,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 199.75,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 4,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 159.8,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 5,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 133.16,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 6,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 114.14,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 7,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 99.87,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 8,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 88.77,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 9,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 79.9,
				InterestRate: null,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 10,
				PaymentSystemName: 'Visa',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Visa',
			},
			{
				Value: 799,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard à vista',
			},
			{
				Value: 399.5,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 2,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 2 vezes sem juros',
			},
			{
				Value: 266.33,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 3,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 3 vezes sem juros',
			},
			{
				Value: 199.75,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 4,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 4 vezes sem juros',
			},
			{
				Value: 159.8,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 5,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 5 vezes sem juros',
			},
			{
				Value: 133.16,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 6,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 6 vezes sem juros',
			},
			{
				Value: 124.88,
				InterestRate: 2.3,
				TotalValuePlusInterestRate: 874.16,
				NumberOfInstallments: 7,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 7 vezes com juros',
			},
			{
				Value: 110.48,
				InterestRate: 2.3,
				TotalValuePlusInterestRate: 883.84,
				NumberOfInstallments: 8,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 8 vezes com juros',
			},
			{
				Value: 99.29,
				InterestRate: 2.3,
				TotalValuePlusInterestRate: 893.61,
				NumberOfInstallments: 9,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 9 vezes com juros',
			},
			{
				Value: 98.46,
				InterestRate: 3.99,
				TotalValuePlusInterestRate: 984.6,
				NumberOfInstallments: 10,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 10 vezes com juros',
			},
			{
				Value: 91.15,
				InterestRate: 3.99,
				TotalValuePlusInterestRate: 1002.65,
				NumberOfInstallments: 11,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 11 vezes com juros',
			},
			{
				Value: 85.08,
				InterestRate: 3.99,
				TotalValuePlusInterestRate: 1020.96,
				NumberOfInstallments: 12,
				PaymentSystemName: 'Mastercard',
				PaymentSystemGroupName: 'creditCardPaymentGroup',
				Name: 'Mastercard 12 vezes com juros',
			},
			{
				Value: 799,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Vale',
				PaymentSystemGroupName: 'giftCardPaymentGroup',
				Name: 'Vale à vista',
			},
			{
				Value: 799,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Promissory',
				PaymentSystemGroupName: 'promissoryPaymentGroup',
				Name: 'Promissory à vista',
			},
			{
				Value: 799,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Customer Credit',
				PaymentSystemGroupName: 'creditControlPaymentGroup',
				Name: 'Customer Credit à vista',
			},
			{
				Value: 759.05,
				InterestRate: 0,
				TotalValuePlusInterestRate: 759.05,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Pix',
				PaymentSystemGroupName: 'instantPaymentPaymentGroup',
				Name: 'Pix à vista',
			},
			{
				Value: 799,
				InterestRate: 0,
				TotalValuePlusInterestRate: 799,
				NumberOfInstallments: 1,
				PaymentSystemName: 'Dinheiro',
				PaymentSystemGroupName: 'custom202PaymentGroupPaymentGroup',
				Name: 'Dinheiro à vista',
			},
		],
		DiscountHighLight: [],
		GiftSkuIds: ['880421', '880420'],
		Teasers: [],
		BuyTogether: [],
		ItemMetadataAttachment: [],
		Price: 799,
		ListPrice: 980,
		PriceWithoutDiscount: 799,
		RewardValue: 50,
		PriceValidUntil: '2023-10-06T21:48:06Z',
		AvailableQuantity: 1000000,
		IsAvailable: true,
		Tax: 0,
		DeliverySlaSamples: [
			{
				DeliverySlaPerTypes: [],
				Region: null,
			},
		],
		GetInfoErrorMessage: null,
		CacheVersionUsedToCallCheckout: 'EAAEBCAC1E264AA392D6D5FD37BEC108_',
		PaymentOptions: {
			installmentOptions: [
				{
					paymentSystem: '2',
					bin: null,
					paymentName: 'Visa',
					paymentGroupName: 'creditCardPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: null,
							interestRate: null,
							value: 79900,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: null,
									interestRate: null,
									value: 79900,
									total: 79900,
								},
							],
						},
						{
							count: 2,
							hasInterestRate: null,
							interestRate: null,
							value: 39950,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 2,
									hasInterestRate: null,
									interestRate: null,
									value: 39950,
									total: 79900,
								},
							],
						},
						{
							count: 3,
							hasInterestRate: null,
							interestRate: null,
							value: 26633,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 3,
									hasInterestRate: null,
									interestRate: null,
									value: 26633,
									total: 79900,
								},
							],
						},
						{
							count: 4,
							hasInterestRate: null,
							interestRate: null,
							value: 19975,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 4,
									hasInterestRate: null,
									interestRate: null,
									value: 19975,
									total: 79900,
								},
							],
						},
						{
							count: 5,
							hasInterestRate: null,
							interestRate: null,
							value: 15980,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 5,
									hasInterestRate: null,
									interestRate: null,
									value: 15980,
									total: 79900,
								},
							],
						},
						{
							count: 6,
							hasInterestRate: null,
							interestRate: null,
							value: 13316,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 6,
									hasInterestRate: null,
									interestRate: null,
									value: 13316,
									total: 79900,
								},
							],
						},
						{
							count: 7,
							hasInterestRate: null,
							interestRate: null,
							value: 11414,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 7,
									hasInterestRate: null,
									interestRate: null,
									value: 11414,
									total: 79900,
								},
							],
						},
						{
							count: 8,
							hasInterestRate: null,
							interestRate: null,
							value: 9987,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 8,
									hasInterestRate: null,
									interestRate: null,
									value: 9987,
									total: 79900,
								},
							],
						},
						{
							count: 9,
							hasInterestRate: null,
							interestRate: null,
							value: 8877,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 9,
									hasInterestRate: null,
									interestRate: null,
									value: 8877,
									total: 79900,
								},
							],
						},
						{
							count: 10,
							hasInterestRate: null,
							interestRate: null,
							value: 7990,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 10,
									hasInterestRate: null,
									interestRate: null,
									value: 7990,
									total: 79900,
								},
							],
						},
					],
				},
				{
					paymentSystem: '4',
					bin: null,
					paymentName: 'Mastercard',
					paymentGroupName: 'creditCardPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: false,
							interestRate: 0,
							value: 79900,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: false,
									interestRate: 0,
									value: 79900,
									total: 79900,
								},
							],
						},
						{
							count: 2,
							hasInterestRate: false,
							interestRate: 0,
							value: 39950,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 2,
									hasInterestRate: false,
									interestRate: 0,
									value: 39950,
									total: 79900,
								},
							],
						},
						{
							count: 3,
							hasInterestRate: false,
							interestRate: 0,
							value: 26633,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 3,
									hasInterestRate: false,
									interestRate: 0,
									value: 26633,
									total: 79900,
								},
							],
						},
						{
							count: 4,
							hasInterestRate: false,
							interestRate: 0,
							value: 19975,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 4,
									hasInterestRate: false,
									interestRate: 0,
									value: 19975,
									total: 79900,
								},
							],
						},
						{
							count: 5,
							hasInterestRate: false,
							interestRate: 0,
							value: 15980,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 5,
									hasInterestRate: false,
									interestRate: 0,
									value: 15980,
									total: 79900,
								},
							],
						},
						{
							count: 6,
							hasInterestRate: false,
							interestRate: 0,
							value: 13316,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 6,
									hasInterestRate: false,
									interestRate: 0,
									value: 13316,
									total: 79900,
								},
							],
						},
						{
							count: 7,
							hasInterestRate: true,
							interestRate: 230,
							value: 12488,
							total: 87416,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 7,
									hasInterestRate: true,
									interestRate: 230,
									value: 12488,
									total: 87416,
								},
							],
						},
						{
							count: 8,
							hasInterestRate: true,
							interestRate: 230,
							value: 11048,
							total: 88384,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 8,
									hasInterestRate: true,
									interestRate: 230,
									value: 11048,
									total: 88384,
								},
							],
						},
						{
							count: 9,
							hasInterestRate: true,
							interestRate: 230,
							value: 9929,
							total: 89361,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 9,
									hasInterestRate: true,
									interestRate: 230,
									value: 9929,
									total: 89361,
								},
							],
						},
						{
							count: 10,
							hasInterestRate: true,
							interestRate: 399,
							value: 9846,
							total: 98460,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 10,
									hasInterestRate: true,
									interestRate: 399,
									value: 9846,
									total: 98460,
								},
							],
						},
						{
							count: 11,
							hasInterestRate: true,
							interestRate: 399,
							value: 9115,
							total: 100265,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 11,
									hasInterestRate: true,
									interestRate: 399,
									value: 9115,
									total: 100265,
								},
							],
						},
						{
							count: 12,
							hasInterestRate: true,
							interestRate: 399,
							value: 8508,
							total: 102096,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 12,
									hasInterestRate: true,
									interestRate: 399,
									value: 8508,
									total: 102096,
								},
							],
						},
					],
				},
				{
					paymentSystem: '16',
					bin: null,
					paymentName: 'Vale',
					paymentGroupName: 'giftCardPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: false,
							interestRate: 0,
							value: 79900,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: false,
									interestRate: 0,
									value: 79900,
									total: 79900,
								},
							],
						},
					],
				},
				{
					paymentSystem: '17',
					bin: null,
					paymentName: 'Promissory',
					paymentGroupName: 'promissoryPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: false,
							interestRate: 0,
							value: 79900,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: false,
									interestRate: 0,
									value: 79900,
									total: 79900,
								},
							],
						},
					],
				},
				{
					paymentSystem: '64',
					bin: null,
					paymentName: 'Customer Credit',
					paymentGroupName: 'creditControlPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: false,
							interestRate: 0,
							value: 79900,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: false,
									interestRate: 0,
									value: 79900,
									total: 79900,
								},
							],
						},
					],
				},
				{
					paymentSystem: '125',
					bin: null,
					paymentName: 'Pix',
					paymentGroupName: 'instantPaymentPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: false,
							interestRate: 0,
							value: 75905,
							total: 75905,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: false,
									interestRate: 0,
									value: 75905,
									total: 75905,
								},
							],
						},
					],
				},
				{
					paymentSystem: '202',
					bin: null,
					paymentName: 'Dinheiro',
					paymentGroupName: 'custom202PaymentGroupPaymentGroup',
					value: 79900,
					installments: [
						{
							count: 1,
							hasInterestRate: false,
							interestRate: 0,
							value: 79900,
							total: 79900,
							sellerMerchantInstallments: [
								{
									id: 'MAEZTRAIO',
									count: 1,
									hasInterestRate: false,
									interestRate: 0,
									value: 79900,
									total: 79900,
								},
							],
						},
					],
				},
			],
			paymentSystems: [
				{
					id: 16,
					name: 'Vale',
					groupName: 'giftCardPaymentGroup',
					validator: null,
					stringId: '16',
					template: 'giftCardPaymentGroup-template',
					requiresDocument: false,
					isCustom: false,
					description: null,
					requiresAuthentication: false,
					dueDate: '2022-10-13T21:32:01.4951237Z',
					availablePayments: null,
				},
				{
					id: 17,
					name: 'Promissory',
					groupName: 'promissoryPaymentGroup',
					validator: null,
					stringId: '17',
					template: 'promissoryPaymentGroup-template',
					requiresDocument: false,
					isCustom: false,
					description: null,
					requiresAuthentication: false,
					dueDate: '2022-10-13T21:33:01.4951237Z',
					availablePayments: null,
				},
				{
					id: 4,
					name: 'Mastercard',
					groupName: 'creditCardPaymentGroup',
					validator: null,
					stringId: '4',
					template: 'creditCardPaymentGroup-template',
					requiresDocument: false,
					isCustom: false,
					description: null,
					requiresAuthentication: false,
					dueDate: '2022-10-13T21:32:01.4951237Z',
					availablePayments: null,
				},
				{
					id: 64,
					name: 'Customer Credit',
					groupName: 'creditControlPaymentGroup',
					validator: null,
					stringId: '64',
					template: 'creditControlPaymentGroup-template',
					requiresDocument: false,
					isCustom: false,
					description: null,
					requiresAuthentication: false,
					dueDate: '2022-10-13T21:32:01.4951237Z',
					availablePayments: null,
				},
				{
					id: 202,
					name: 'Dinheiro',
					groupName: 'custom202PaymentGroupPaymentGroup',
					validator: null,
					stringId: '202',
					template: 'custom202PaymentGroupPaymentGroup-template',
					requiresDocument: false,
					isCustom: true,
					description: '',
					requiresAuthentication: false,
					dueDate: '2022-10-16T21:33:01.4951237Z',
					availablePayments: null,
				},
				{
					id: 2,
					name: 'Visa',
					groupName: 'creditCardPaymentGroup',
					validator: null,
					stringId: '2',
					template: 'creditCardPaymentGroup-template',
					requiresDocument: false,
					isCustom: false,
					description: null,
					requiresAuthentication: false,
					dueDate: '2022-10-13T21:32:01.4951237Z',
					availablePayments: null,
				},
				{
					id: 125,
					name: 'Pix',
					groupName: 'instantPaymentPaymentGroup',
					validator: null,
					stringId: '125',
					template: 'instantPaymentPaymentGroup-template',
					requiresDocument: false,
					isCustom: false,
					description: null,
					requiresAuthentication: false,
					dueDate: '2022-10-13T21:32:01.4951237Z',
					availablePayments: null,
				},
			],
			payments: [],
			giftCards: [],
			giftCardMessages: [],
			availableAccounts: [],
			availableTokens: [],
		},
	},
};
